module.exports = __webpack_public_path__ + "img/photo_upload_2.0.8abf8af4.png";